export function setStorageItemWithExpiry(key: string, value: string, ttl?: number) {
  const now = new Date();

  const item = {
    value,
    expiry: ttl ? now.getTime() + ttl : null,
  };
  localStorage.setItem(key, JSON.stringify(item));
}

export function getStorageItemWithExpiry(key: string) {
  const itemStr = localStorage.getItem(key);

  if (!itemStr) {
    return null;
  }

  const item = JSON.parse(itemStr);
  const now = new Date();

  if (item.expiry && now.getTime() > item.expiry) {
    localStorage.removeItem(key);
    return null;
  }
  return item.value;
}
